import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  data: () => ({
    
  }),
  methods: {
    can_use_ai(){
      const {can_use_ai} = this.active_company_settings.ai_config
      return can_use_ai
    },
    can_use_ai_to_create_form(){
      const {can_use_ai, can_use_on_form, on_form_to_create} = this.active_company_settings.ai_config
      return can_use_ai && can_use_on_form && on_form_to_create
    },
    can_use_ai_on_flow_to_check_image(){
      const {can_use_ai, can_use_on_flow, on_flow_to_check_image} = this.active_company_settings.ai_config
      return can_use_ai && can_use_on_flow && on_flow_to_check_image
    },
    can_use_ai_on_done_form_to_report(){
      const {can_use_ai, can_use_on_done_form, on_done_form_to_report} = this.active_company_settings.ai_config
      return can_use_ai && can_use_on_done_form && on_done_form_to_report
    },
  },
  computed: {
    active_company() {
      if (this.profile && this.profile.company){
        return this.profile.company.data.attributes
      }
      // if (this.companyID && this.allMyCompanies) {
      //   return this.allMyCompanies.find((o) => o.id == Number(this.companyID));
      // }
    },
    active_company_settings() {
      if (this.active_company) {
        const {ai_config, white_label_config, trial, id} = this.profile.company.data.attributes
        return {id, ai_config}
      }
    },
    ...mapState({
      // companyID: (state) => state.Company.companyID,
      // allMyCompanies: (state) => state.Company.allSolutions,
      // data: state=> state.Module.state_var
      profile: state => state.User.oneUser,
    }),
  },
};